<div
  #trustbox
  class="trustpilot-widget"
  [attr.data-locale]="locale"
  [attr.data-template-id]="templateId"
  [attr.data-businessunit-id]="businessUnitId"
  [attr.data-style-height]="styleHeight"
  [attr.data-style-width]="styleWidth"
  [attr.data-theme]="theme"
  [attr.data-token]="token"
>
  <a href="https://www.trustpilot.com/review/www.eezyimport.com" target="_blank" rel="noopener">Trustpilot</a>
</div>
